import { render } from "./RegLog.vue?vue&type=template&id=9f08277e&scoped=true"
import script from "./RegLog.vue?vue&type=script&lang=js"
export * from "./RegLog.vue?vue&type=script&lang=js"

import "./RegLog.vue?vue&type=style&index=0&id=9f08277e&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f08277e"]])

export default __exports__